<script lang="ts" setup>
import type { Ref } from 'vue';
import { onBeforeMount, ref, computed } from 'vue';
import StudentTable from './components/StudentTable.vue';
import BillingAdminTable from './components/BillingAdminTable.vue';
import ClinicianTable from './components/ClinicianTable.vue';
import FacilitatorsTable from './components/FacilitatorsTable.vue';
import SchoolAdminsTable from './components/SchoolAdminsTable.vue';
import Disciplines from './components/Disciplines.vue';
import Services from './components/Services.vue';
import SubOrganizations from './components/OrganizationsConnectionsSubOrganizationTable.vue';
import ParentsTable from './components/ParentsTable.vue';
import Buildings from './components/Buildings/Buildings.vue';
import Grades from './components/Grades/Grades.vue';
import { can, useRouting, usePersonTypes } from '@/composables';
import { PERMISSIONS, PEOPLE_TYPES } from '@/enum';
import { useAuthStore, PersonStores } from '@/store';

const $routing = useRouting();
const organizationId: Ref<number> = ref(0);
const profileStore = PersonStores.useUserProfileStore();

onBeforeMount(() => {
  organizationId.value = parseInt($routing.route.params.id as string);
});

const isClinician = computed(() =>
  usePersonTypes.isClinician(profileStore.person?.people_type?.acronym as PEOPLE_TYPES),
);

const isStudent = computed(() => usePersonTypes.isStudent(profileStore.person?.people_type?.acronym as PEOPLE_TYPES));

//TODO: add once backend --> can([PERMISSIONS.ORGANIZATION_BILLING_ADMIN_INDEX]) &&
const canSeeBillingAdminTable = computed(() => useAuthStore().currentInstanceIsMasterTenant);
</script>

<template>
  <StudentTable v-if="can([PERMISSIONS.ORGANIZATION_STUDENTS_INDEX])" />
  <ClinicianTable
    v-if="can([PERMISSIONS.ORGANIZATION_CLINICIANS_INDEX, PERMISSIONS.ORGANIZATION_CLINICIANS_INDEX_SELF])"
  />
  <ParentsTable v-if="can([PERMISSIONS.ORGANIZATION_PARENTS_INDEX])" :organization-id="organizationId" />
  <FacilitatorsTable v-if="can([PERMISSIONS.ORGANIZATION_FACILITATORS_INDEX])" />
  <SchoolAdminsTable v-if="can([PERMISSIONS.ORGANIZATION_SCHOOL_ADMIN_INDEX])" />
  <BillingAdminTable v-if="canSeeBillingAdminTable" />
  <Buildings :organization-id="organizationId" />

  <Grades v-if="isClinician || isStudent" :organization-id="organizationId" />
  <SubOrganizations v-if="can([PERMISSIONS.ORGANIZATION_SUB_ORGANIZATIONS])" />
  <div v-if="can([PERMISSIONS.ORGANIZATION_DISCIPLINES_INDEX])" class="flex-1 min-w-max mb-4">
    <Disciplines :organization-id="organizationId" />
  </div>
  <div v-if="can([PERMISSIONS.ORGANIZATION_SERVICES_INDEX])" class="flex-1 min-w-max mb-4">
    <Services :organization-id="organizationId" header="Event Types" />
  </div>
</template>
